"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeAttributeFilterSelectionHandler = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var effects_1 = require("redux-saga/effects");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var general_1 = require("../../../events/general");
var filters_1 = require("../../../events/filters");
var filterContext_1 = require("../../../store/filterContext");
var common_1 = require("../common");
var filterContextSelectors_1 = require("../../../store/filterContext/filterContextSelectors");
var eventDispatcher_1 = require("../../../store/_infra/eventDispatcher");
function changeAttributeFilterSelectionHandler(ctx, cmd) {
    var _a, elements, filterLocalId, selectionType, affectedFilter, changedFilter, childFiltersIds;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = cmd.payload, elements = _a.elements, filterLocalId = _a.filterLocalId, selectionType = _a.selectionType;
                return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectFilterContextAttributeFilterByLocalId(cmd.payload.filterLocalId))];
            case 1:
                affectedFilter = _b.sent();
                if (!affectedFilter) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Filter with filterLocalId " + filterLocalId + " not found.");
                }
                return [4 /*yield*/, effects_1.put(filterContext_1.filterContextActions.updateAttributeFilterSelection({
                        elements: elements,
                        filterLocalId: filterLocalId,
                        negativeSelection: selectionType === "NOT_IN",
                    }))];
            case 2:
                _b.sent();
                return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectFilterContextAttributeFilterByLocalId(cmd.payload.filterLocalId))];
            case 3:
                changedFilter = _b.sent();
                ts_invariant_1.default(changedFilter, "Inconsistent state in attributeFilterChangeSelectionCommandHandler");
                return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectAttributeFilterDescendants(changedFilter.attributeFilter.localIdentifier))];
            case 4:
                childFiltersIds = _b.sent();
                return [4 /*yield*/, effects_1.all(childFiltersIds.map(function (childFilterId) {
                        return effects_1.put(filterContext_1.filterContextActions.updateAttributeFilterSelection({
                            filterLocalId: childFilterId,
                            elements: {
                                uris: [],
                            },
                            negativeSelection: true,
                        }));
                    }))];
            case 5:
                _b.sent();
                return [4 /*yield*/, eventDispatcher_1.dispatchDashboardEvent(filters_1.attributeFilterSelectionChanged(ctx, changedFilter, cmd.correlationId))];
            case 6:
                _b.sent();
                return [4 /*yield*/, effects_1.call(common_1.dispatchFilterContextChanged, ctx, cmd)];
            case 7:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
exports.changeAttributeFilterSelectionHandler = changeAttributeFilterSelectionHandler;
//# sourceMappingURL=changeAttributeFilterSelectionHandler.js.map